import Vue from "vue";
import I18NextVue from "i18next-vue";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { defaultLanguage } from "@/utils/locales";
import { languageStorageName } from "@/store/localStorage";

// General translation files
import de from "@/locales/de.json";
import en from "@/locales/en.json";
import es from "@/locales/es.json";
import fr from "@/locales/fr.json";
import it from "@/locales/it.json";
import ro from "@/locales/ro.json";
import ar from "@/locales/ar.json";
import ja from "@/locales/ja.json";

// Takeda specific translations
import enTakeda from "@/locales/takeda/takeda.en.json";
import jaTakeda from "@/locales/takeda/takeda.ja.json";

export const translationResources = {
  en: {
    translation: en,
    takeda: enTakeda,
  },
  fr: {
    translation: fr,
  },
  es: {
    translation: es,
  },
  ro: {
    translation: ro,
  },
  it: {
    translation: it,
  },
  de: {
    translation: de,
  },
  ar: {
    translation: ar,
  },
  ja: {
    translation: ja,
    takeda: jaTakeda,
  },
};

let i18nextPromise = i18next
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: defaultLanguage,
    // Derived from translation resources so users with unsupported browser languages
    // can still see the interface in their language if translations exist
    supportedLngs: Object.keys(translationResources),
    resources: translationResources,
    ns: ["translation", "takeda"],
    defaultNS: "translation",
    // See options https://github.com/i18next/i18next-browser-languageDetector
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: languageStorageName,
    },
  })
  .then(() => {
    // By Intl.PluralRules defaults Japanese doesn't have plural forms, only _other is used
    // Force Japanese to use singular (_one) and plural (_other) forms
    // This is needed to handle special case to have archiveConfirm_one instead of archiveConfirm_other for count=1
    const originalGetSuffix = i18next.services.pluralResolver.getSuffix.bind(
      i18next.services.pluralResolver
    );
    i18next.services.pluralResolver.getSuffix = (lng, count, options = {}) => {
      if (lng === "ja" && !options.ordinal) {
        return count === 1 ? "_one" : "_other";
      }
      return originalGetSuffix(lng, count, options);
    };
  });

export function useI18Next(app) {
  i18nextPromise;
  Vue.use(I18NextVue, { i18next });
  return app;
}

export default i18next;
